
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"57","height":"59","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30.209 51.38V29.125l22.267 22.257H30.21zm-6.484 0H8.042V6.868h15.733v44.514h-.05zm6.484-44.312c5.68-.1 10.606-.35 13.37 3.71.453.651.905 1.453 1.358 2.255-.101-.1 2.814 5.514-.905 10.878-.1.25-.302.501-.453.651-3.87 4.763-9.902 3.41-13.37 3.76V7.068zM0 59h57V0H0v59z"}})])
          )
        }
      }
    